// extracted by mini-css-extract-plugin
module.exports = {"generic_ui":"GenericUI_generic_ui__qBYXt"};